import React,{useState}  from 'react'
import {Box,Typography,Container,Button, TextField, InputAdornment, InputLabel} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowIcon from '@mui/icons-material/ArrowBackRounded';
import CircularProgress from '@mui/material/CircularProgress';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import {IconButton} from "@mui/material"
import {useNavigate} from 'react-router-dom'
import create_test from '../Redux/reducers/create_test'
import { add_test} from "../Redux/testSlice";
import { add_tests} from "../Redux/testsSlice";
import Header from '../Components/Header'
import CustomDialog from '../Components/CustomDialog'
import useMediaQuery from '@mui/material/useMediaQuery';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import UserInput from '../Components/UserInput'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import axios from 'axios'
import Snackbar from '@mui/material/Snackbar'
import GridViewContainer from '../Components/GridViewContainer';
import AutoInput from '../Components/AutoInput';
import MultiInput from '../Components/MultiInput';
import { add_activities,add_activity } from '../Redux/settingSlice';
import dayjs from 'dayjs';
import TimeInput from '../Components/TimeInput';
import DateInput from '../Components/DateInput';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Select from '@mui/material/Select';
import { Alarm, ArrowDropDownCircleOutlined, CalendarTodayOutlined, MicRounded, PeopleOutlineOutlined, QuizOutlined, Search } from '@mui/icons-material';
import { add_template } from '../Redux/templatesSlice';
import ConfirmDialog from '../Components/ConfirmDialog';


  const Accordion = styled((props) => (
	<MuiAccordion disableGutters elevation={4} square {...props} />
))(({ theme }) => ({
	'&:not(:last-child)': {
		borderBottom: 0,
	},
	'&:before': {
		display: 'none',
	},
	borderRadius:10,
	background:"black"
}));

const AccordionSummary = styled((props) => (
<MuiAccordionSummary
	expandIcon={<ArrowDropDownCircleOutlined sx={{ fontSize: 20 }} />}
	{...props}
/>
))(({ theme }) => ({
	background:theme.palette.mode === 'dark'? 'black': 'white',
	flexDirection: 'row',
	'& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
		transform: 'rotate(90deg)',
	},
	'& .MuiAccordionSummary-content': {
		marginBottom: theme.spacing(1),
	}
}));

const ContainerBox = styled(Box)(({ theme }) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: 7,
        backgroundColor: '#060202'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ffffff',
        borderRadius: 5
    },
    maxHeight:700,
    minHeight:500,
	marginTop:10
}));
	
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
    }),
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
        width: 7,
        backgroundColor: '#000000'
    },
    '&::-webkit-scrollbar-thumb': {
        backgroundColor: '#ffffff',
        borderRadius: 5
    },
	padding: theme.spacing(2),
	background:theme.palette.mode === 'dark'? 'black' : 'white',
    maxHeight:200,
    minHeight:80
}));

const Template = ()=>{

	const theme = useTheme()
	const test = useSelector(state => state?.test.test);
	const navigate = useNavigate()
	const [lang, setLang] = useState(test?.language);
	const [loading, setLoading] = useState(false);
	const [open, setOpen] = React.useState(false);
	const [response_type, setResponse_type] = React.useState("Any");
	const [showDialog, setShowDialog] = React.useState(false);
	const [isNext, setIsNext] = React.useState(false);
    const [expand, setExpand] = React.useState(true);
	const [message, setMessage] = React.useState("");
	const template = useSelector(state => state?.templates.template);
	const [participants, setParticipants] = React.useState([]);
	const user = useSelector(state => state?.auth.user);
	const tests = useSelector(state => state?.tests.tests);
	const [trans, setTrans] = React.useState(false);
    const [search, setSearch] = React.useState("");
    const [filter, setFilter] = React.useState("");
    const [searching, setSearching] = React.useState(false);
	const [results, setResults] = React.useState([1,2,3]);
	const [value, setValue] = React.useState(0);
	const [publicData, setPublicData] = React.useState([]);
	const [privateData, setPrivateData] = React.useState([]);
	const [isRecording, setIsRecording] = React.useState(null)
	const [showConfirm, setShowConfirm] = React.useState(false);
	const [title, setTitle] = React.useState("");
	const [content, setContent] = React.useState("");
	const dispatch = useDispatch()

const handleChangeFilter = (e)=>{
    try {
        setFilter(e.target.value)
    } catch (error) {
        console.log(error)
    }
}

const handleExpand = ()=>{
    try {
        setExpand(prev=>!prev)
    } catch (error) {
        console.log(error)
    }
}

const handleGetTemplates = async ()=>{
    try {

		setLoading(true)

		const data = {
			email:user?.email
		}

        const getTemplates = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}get-templates/`,data,{
			headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${user?.accessToken}`
            }
		}).catch(err=>{
			setLoading(false)
			setMessage("please,check your connection and try again")
			setOpen(true)
			console.log(err)
		})

		if (getTemplates?.status == 200 && getTemplates?.data?.success) {
			setPublicData(getTemplates?.data.publicTemplates)
			setPrivateData(getTemplates?.data.userTemplates)
			// console.log(getTemplates?.data)
		}
		setLoading(false)
    } catch (error) {
        console.log(error)
    }
}

const handleSearch = async ()=>{
    try {

		setSearching(true)

		const data = {
			email:user?.email,
			search:search,
			filter:""
		}

        const getTemplates = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}search-templates/`,data,{
			headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${user?.accessToken}`
            }
		}).catch(err=>{
			setSearching(false)
			setMessage("please,check your connection and try again")
			setOpen(true)
			console.log(err)
		})

		if (getTemplates?.status == 200 && getTemplates?.data?.success) {
			setPublicData(getTemplates?.data.publicTemplates)
			setPrivateData(getTemplates?.data.userTemplates)
			// console.log(getTemplates?.data)
		}
		setSearching(false)
    } catch (error) {
        console.log(error)
    }
}

const handleFilter = async ()=>{
    try {
		setSearching(true)

		const data = {
			email:user?.email,
			search:search,
			filter:filter
		}

        const getTemplates = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}search-templates/`,data,{
			headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${user?.accessToken}`
            }
		}).catch(err=>{
			setSearching(false)
			setMessage("please,check your connection and try again")
			setOpen(true)
			console.log(err)
		})

		if (getTemplates?.status == 200 && getTemplates?.data?.success) {
			setPublicData(getTemplates?.data.publicTemplates)
			setPrivateData(getTemplates?.data.userTemplates)
			// console.log(getTemplates?.data)
		}
		setSearching(false)
    } catch (error) {
        console.log(error)
    }
}

const handleSnackbarClose = ()=>{
	setOpen(false)
}

function CustomTab(props) {
	const { children, value, index, ...other } = props;

	return (
	<div
		role="tabpanel"
		hidden={value !== index}
		id={`simple-tabpanel-${index}`}
		aria-labelledby={`simple-tab-${index}`}
		{...other}
	>
		{value === index && <ContainerBox sx={{ p: 1 }}>{children}</ContainerBox>}
	</div>
	);
}

function a11yProps(index) {
	return {
	  id: `simple-tab-${index}`,
	  'aria-controls': `simple-tabpanel-${index}`,
	};
  }


  const handleTab = (event, newValue) => {
    setValue(newValue);
  };

React.useLayoutEffect(()=>{
	handleSearch()
},[search])

React.useLayoutEffect(()=>{
	handleFilter()
},[filter])

React.useEffect(()=>{
	handleGetTemplates()
},[])

	return(
		<Box width="100%">
			<Header title="Create Assessment">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" color="inherit" href="/dashboard">
						Dashboard
					</Link>
					<Typography sx={{fontSize:12,color:"gray"}}>Templates</Typography>
			</Breadcrumbs>			
			</Header>
			<Container>
				<Snackbar 
					anchorOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}} 
					message={message} 
					onClose={handleSnackbarClose} 
					open={open} 
					autoHideDuration={2000}
				/>
				<Box mb={2} display="flex" flexDirection="row" alignItems="flex-start" justifyContent="space-between" width="100%">
					<Box width="100%">
						<Typography mt={1} mb={1} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
							search
						</Typography>
						<Box>
							<TextField
								placeholder='ex: hiring template...'
								type='search'
								sx={{minHight:25,maxWidth:280}}
								InputProps={{
									endAdornment: (
									<InputAdornment  style={{width:150,justifyContent:"center",alignItems:"center",textAlign:"left"}} position="end">
										{
											searching ? <CircularProgress size={15} sx={{color:"#fff"}}/> : <Search/>
										}
									</InputAdornment>
									)
								}}
								label="search"
								value={search}
								onChange={(e)=>{setSearch(e?.target?.value)}}
							/>
						</Box>
						<Box justifyContent="flex-start" alignItems="flex-start" mt={2} width="50%">
							<FormControl fullWidth>
								<InputLabel mr={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gold"}} id="filter-label">Filter</InputLabel>
								<Select
									labelId="filter-label"
									value={filter}
									label="Filter"
									sx={{height:45,fontSize:14}}
									onChange={handleChangeFilter}
								>
									<MenuItem sx={{fontSize:13}}  value="">None</MenuItem>
									<MenuItem sx={{fontSize:13}}  value="job">Job</MenuItem>
									<MenuItem sx={{fontSize:13}} value="exam">Exam</MenuItem>
									<MenuItem sx={{fontSize:13}} value="event">Event</MenuItem>
									<MenuItem sx={{fontSize:13}} value="RH">RH</MenuItem>
									<MenuItem sx={{fontSize:13}} value="IT">IT</MenuItem>
									<MenuItem sx={{fontSize:13}} value="Finance">Finance</MenuItem>
									<MenuItem sx={{fontSize:13}} value="Marketing">Marketing</MenuItem>
									<MenuItem sx={{fontSize:13}} value="Electric">Electric</MenuItem>
									<MenuItem sx={{fontSize:13}} value="Mechanic">Mechanic</MenuItem>
									<MenuItem sx={{fontSize:13}} value="Electronic">Electronic</MenuItem>
									<MenuItem sx={{fontSize:13}} value="Management">Management</MenuItem>
									<MenuItem sx={{fontSize:13}} value="Logistic">Logistic</MenuItem>
									<MenuItem sx={{fontSize:13}} value="Others">Others</MenuItem>
								</Select>
							</FormControl>
						</Box>
					</Box>
					<Button onClick={(e)=>{
						e?.preventDefault()
						navigate("/createTemplate")
					}}  sx={{backgroundColor:"#fff",color:"#000",margin:2,marginLeft:2,fontFamily:"dinofans",fontSize:11,width:120,justifyContent:"center",alignItems:"center"}}>
						Create
					</Button>
				</Box>
				<Box >
					<Box sx={{ borderBottom: 0,width:"50%" }}>
						<Tabs value={value} onChange={handleTab} aria-label="basic tabs example">
							<Tab sx={{fontSize:12,fontFamily:"dinofans",color:value == 0 ? "gold" : "white"}} iconPosition="start" icon={<PeopleOutlineOutlined fontSize='small' />} label="Public" {...a11yProps(0)} />
							<Tab sx={{fontSize:12,fontFamily:"dinofans",color:value == 1 ? "gold" : "white"}} iconPosition="start" icon={<AccountCircle fontSize='small'/>} label="My templates" {...a11yProps(1)} />
						</Tabs>					
					</Box>					
				</Box>
				<CustomTab value={value} index={1}>
				{
					privateData?.length > 0 ?                 
						<Box mt={2} mb={5}>
							<Typography  mb={1} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
								Available Templates
							</Typography>
						</Box>
					: privateData?.length == 0 && loading ?
						<Box mt={2} mb={5}>
							<CircularProgress size={20} sx={{color:"#fff"}}/>
						</Box>
					:
						<Box mt={10} mb={5} textAlign="center" width="100%">
							<Box textAlign="center" mb={2}>
								<img  width={50} height={80} src="https://res.cloudinary.com/irihocloud/image/upload/v1731198104/r14klvgmrdt5syskccyi.gif" alt="keep up" />
							</Box>
							<Typography  mb={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
								Templates could not be found
							</Typography>
						</Box>
				}
                <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent={privateData?.length == 1 ? "space-evenly" : "flex-start"} alignItems="flex-start" width="100%">
                    {
                        privateData?.map((item,index)=>(
							<Box key={index} m={1} sx={{backgroundColor:"black",borderRadius:5,width:{xs:"100%",md:'45%'}}}>
								<Typography ml={3} mb={1} mt={2} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
									{item?.visibility}
								</Typography>
								<Box p={1} display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-evenly" alignItems="flex-start" width="100%">
                                    <Box>
                                        <Typography mt={1} mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                            Title 
                                        </Typography>
                                        <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans"}}>
                                           {item?.name}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography mt={1} mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                            Type 
                                        </Typography>
                                        <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans"}}>
                                           {item?.type}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box p={1} ml={2}>
                                    <Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                        Description
                                    </Typography>
                                    <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
                                       {item?.description}
                                    </Typography>
                                </Box>
								<Typography ml={3} mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
									settings
								</Typography>
								<Box display="flex" flexDirection="row" justifyContent="space-evenly" alignItems="center">
									<Box>
										<QuizOutlined fontSize='small'/>
										<Typography sx={{fontSize:10,fontWeight:400}}>
											{item?.level}
										</Typography>
									</Box>
									<Box>
										<CalendarTodayOutlined fontSize='small'/>
										<Typography sx={{fontSize:10,fontWeight:400}}>
										   {item?.start_date}
										</Typography>
									</Box>
									<Box>
										<Alarm fontSize='small'/>
										<Typography sx={{fontSize:10,fontWeight:400}}>
											{item?.start_moment}
										</Typography>
									</Box>
								</Box>
                                <Box p={1}>
                                    <Accordion sx={{width:{xs:"100%",md:"95%"}}} expanded={expand} onChange={handleExpand}>
                                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                            <Box>
                                            <Typography style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                                {item?.sections.length} Sections
                                            </Typography>
                                            </Box>
                                        </AccordionSummary>
                                        <AccordionDetails >
												{
													item?.sections.map((itm,index)=>(
														<Box key={index}>
															<Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
																Section {index+1}
															</Typography>
															<Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="flex-start" alignItems="flex-start">
																<Box m={1} width="40%">
																	<Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
																		Title
																	</Typography>
																	<Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
																		{itm?.title}
																	</Typography>
																</Box>
																<Box m={1} width="40%">
																	<Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
																		Language
																	</Typography>
																	<Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
																		{itm?.language}
																	</Typography>
																</Box>
																<Box m={1} width="40%">
																	<Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
																		Duration
																	</Typography>
																	<Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
																		{itm?.duration} min
																	</Typography>
																</Box>
																<Box m={1} width="40%">
																	<Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
																		Questions
																	</Typography>
																	<Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
																		{itm?.questions.length}
																	</Typography>
																</Box>
																<Box m={1} width="90%">
																	<Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
																		Description
																	</Typography>
																	<Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
																		{itm?.description}
																	</Typography>
																</Box>
															</Box>
														</Box>
													))
												}
                                        </AccordionDetails>
                                    </Accordion>
									<Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="center" alignItems="center">
										<Button onClick={(e)=>{
											e?.preventDefault()
											dispatch(add_template(item))
											setTitle("Assessment notice")
											setContent("By clicking to continue, you will create an assessment based on this template")
											setShowConfirm(true)
										}}  sx={{backgroundColor:"gold",margin:1,borderColor:"gold",fontFamily:"dinofans",fontSize:12,width:100,justifyContent:"center",alignItems:"center"}}>
											Use
										</Button>
										<Button onClick={(e)=>{
											e?.preventDefault()
											dispatch(add_template(item))
											navigate("/templateInfo")
										}}  sx={{backgroundColor:"maroon",margin:1,color:"#fff",fontFamily:"dinofans",fontSize:12,width:100,justifyContent:"center",alignItems:"center"}}>
											View
										</Button>
									</Box>
                                </Box>
                            </Box>
                        ))
                    }
                </Box>
				</CustomTab>
				<CustomTab value={value} index={0}>
				{
					publicData?.length > 0 ?                 
						<Box mt={2} mb={5}>
							<Typography  mb={1} style={{fontSize:15,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
								Available Templates
							</Typography>
						</Box>
					: publicData?.length == 0 && loading ?
						<Box mt={2} mb={5}>
							<CircularProgress size={20} sx={{color:"#fff"}}/>
						</Box>
					:
						<Box  mt={10} mb={5} textAlign="center" width="100%">
							<Box textAlign="center" mb={2}>
								<img  width={50} height={80} src="https://res.cloudinary.com/irihocloud/image/upload/v1731198104/r14klvgmrdt5syskccyi.gif" alt="keep up" />
							</Box>
							<Typography  mb={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
								Templates could not be found
							</Typography>
						</Box>
				}
                <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent={publicData?.length == 1 ? "space-evenly" : "flex-start"} alignItems="flex-start" width="100%">
                    {
                        publicData?.map((item,index)=>(
                            <Box key={index} m={1} sx={{backgroundColor:"black",borderRadius:5,width:{xs:400,md:'45%'}}}>
								<Typography ml={3} mb={1} mt={2} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
									{item?.visibility}
								</Typography>
								<Box p={1} display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-evenly" alignItems="flex-start" width="100%">
                                    <Box>
                                        <Typography mt={1} mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                            Title 
                                        </Typography>
                                        <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans"}}>
                                           {item?.name}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography mt={1} mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                            Type 
                                        </Typography>
                                        <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400,fontFamily:"dinofans"}}>
                                           {item?.type}
                                        </Typography>
                                    </Box>
                                </Box>
                                <Box p={1} ml={2}>
                                    <Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                        Description
                                    </Typography>
                                    <Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
                                       {item?.description}
                                    </Typography>
                                </Box>
								<Typography ml={3} mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
									settings
								</Typography>
								<Box display="flex" flexDirection="row" justifyContent="space-evenly" alignItems="center">
									<Box>
										<QuizOutlined fontSize='small'/>
										<Typography sx={{fontSize:10,fontWeight:400}}>
											{item?.level}
										</Typography>
									</Box>
									<Box>
										<CalendarTodayOutlined fontSize='small'/>
										<Typography sx={{fontSize:10,fontWeight:400}}>
										   {item?.start_date}
										</Typography>
									</Box>
									<Box>
										<Alarm fontSize='small'/>
										<Typography sx={{fontSize:10,fontWeight:400}}>
											{item?.start_moment}
										</Typography>
									</Box>
								</Box>
                                <Box p={1}>
                                    <Accordion sx={{width:{xs:"100%",md:"95%"}}} expanded={expand} onChange={handleExpand}>
                                        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                                            <Box>
                                            <Typography style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
                                                {item?.sections.length} Sections
                                            </Typography>
                                            </Box>
                                        </AccordionSummary>
                                        <AccordionDetails >
												{
													item?.sections.map((itm,index)=>(
														<Box key={index}>
															<Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gold"}}>
																Section {index+1}
															</Typography>
															<Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="flex-start" alignItems="flex-start">
																<Box m={1} width="40%">
																	<Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
																		Title
																	</Typography>
																	<Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
																		{itm?.title}
																	</Typography>
																</Box>
																<Box m={1} width="40%">
																	<Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
																		Language
																	</Typography>
																	<Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
																		{itm?.language}
																	</Typography>
																</Box>
																<Box m={1} width="40%">
																	<Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
																		Duration
																	</Typography>
																	<Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
																		{itm?.duration} min
																	</Typography>
																</Box>
																<Box m={1} width="40%">
																	<Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
																		Questions
																	</Typography>
																	<Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
																		{itm?.questions.length}
																	</Typography>
																</Box>
																<Box m={1} width="90%">
																	<Typography mb={1} style={{fontSize:10,fontWeight:400,fontFamily:"dinofans",color:"gray"}}>
																		Description
																	</Typography>
																	<Typography mt={1} mb={1} style={{fontSize:12,fontWeight:400}}>
																		{itm?.description}
																	</Typography>
																</Box>
															</Box>
														</Box>
													))
												}
                                        </AccordionDetails>
                                    </Accordion>
									<Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="center" alignItems="center">
										<Button onClick={(e)=>{
											e?.preventDefault()
											dispatch(add_template(item))
											setTitle("Assessment notice")
											setContent("By clicking to continue, you will create an assessment based on this template")
											setShowConfirm(true)
										}}  sx={{backgroundColor:"gold",margin:1,borderColor:"gold",fontFamily:"dinofans",fontSize:12,width:100,justifyContent:"center",alignItems:"center"}}>
											Use
										</Button>
										<Button onClick={(e)=>{
											e?.preventDefault()
											dispatch(add_template(item))
											navigate("/templateInfo")
										}}  sx={{backgroundColor:"maroon",margin:1,color:"#fff",fontFamily:"dinofans",fontSize:12,width:100,justifyContent:"center",alignItems:"center"}}>
											View
										</Button>
									</Box>
                                </Box>
                            </Box>
                        ))
                    }
                </Box>
				</CustomTab>
				<ConfirmDialog title={title} content={content} handleClick={()=>{
					navigate("/addParticipant")
				}} visible={showConfirm} setVisible={setShowConfirm}/>
				<CustomDialog data={participants} visible={showDialog} setVisible={setShowDialog}/>
			</Container>
		</Box>
		)
}

export default Template